var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 5,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0208 8.625H16.6731C16.5533 8.16126 16.2833 7.75025 15.9052 7.45625C15.5271 7.16224 15.0623 7.00179 14.5833 7H12.4167C11.9377 7.00179 11.4729 7.16224 11.0948 7.45625C10.7167 7.75025 10.4467 8.16126 10.3269 8.625H9.97917C9.18931 8.62586 8.43204 8.94001 7.87353 9.49853C7.31501 10.057 7.00086 10.8143 7 11.6042L7 17.0208C7.00086 17.8107 7.31501 18.568 7.87353 19.1265C8.43204 19.685 9.18931 19.9991 9.97917 20H17.0208C17.8106 19.999 18.5678 19.6848 19.1263 19.1263C19.6848 18.5678 19.999 17.8106 20 17.0208V11.6042C19.999 10.8144 19.6848 10.0572 19.1263 9.49869C18.5678 8.9402 17.8106 8.626 17.0208 8.625ZM9.97917 10.25H17.0208C17.38 10.25 17.7244 10.3927 17.9784 10.6466C18.2323 10.9006 18.375 11.245 18.375 11.6042V12.9583H8.625V11.6042C8.625 11.245 8.76767 10.9006 9.02163 10.6466C9.27558 10.3927 9.62002 10.25 9.97917 10.25ZM17.0208 18.375H9.97917C9.62002 18.375 9.27558 18.2323 9.02163 17.9784C8.76767 17.7244 8.625 17.38 8.625 17.0208V14.5833H12.4167C12.4167 14.8707 12.5308 15.1462 12.734 15.3494C12.9371 15.5525 13.2127 15.6667 13.5 15.6667C13.7873 15.6667 14.0629 15.5525 14.266 15.3494C14.4692 15.1462 14.5833 14.8707 14.5833 14.5833H18.375V17.0208C18.375 17.38 18.2323 17.7244 17.9784 17.9784C17.7244 18.2323 17.38 18.375 17.0208 18.375Z",
    fill: "#09041C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobs-icon.ec6cc04a344b2f572532a3b65db6db35.svg";
export { ForwardRef as ReactComponent };